import { prepareRuntime } from './appMount';

async function boot() {
  await prepareRuntime('boot');
  await import('./bootloader');
}

boot().catch((error) => console.error('[rate_card_management_ui] boot failed', error));
